export function localGet(key, default_value = '') {
	let value = window.localStorage.getItem(key);
	try {value = JSON.parse(value);}
	catch (error) {value = '';}
	return value || default_value;
}

export function localSet(key, value) {
	window.localStorage.setItem(key, JSON.stringify(value))
}

export function localRemove(key) {
	window.localStorage.removeItem(key)
}

// 判断内容是否含有表情字符，现有数据库不支持。
export function hasEmoji (str = '') {
	const reg = /[^\u0020-\u007E\u00A0-\u00BE\u2E80-\uA4CF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u0080-\u009F\u2000-\u201f\u2026\u2022\u20ac\r\n]/g;
	return str.match(reg) && str.match(reg).length
}

const CONFIG_LIST = [
    {name: '区服管理', list: [
        {name: '区服组管理', route: '/server/groupList'},
        {name: '区服管理', route: '/server/list'},
        {name: '内网服务器', route: '/server/usageList'},
        {name: '渠道管理', route: '/channel/list'},
        {name: '更新管理', route: '/version/list'},
        {name: '渠道审核', route: '/version/verify_list'},
    ]},
    {name: '玩家管理', list: [
        {name: '账号管理', route: '/player/list'},
        {name: '角色管理', route: '/player/roleList'},
        {name: '协会管理', route: '/league/list'},
        {name: '订单管理', route: '/player/orderList'},
    ]},
    {name: '运营管理', list: [
        {name: '公告管理', route: '/announcement/list'},
        {name: '活动管理', route: '/activity/partList'},
        {name: '社区管理', route: '/community/partList'},
        {name: '推送礼包', route: '/gift/giftList'},
        {name: '礼包兑换码', route: '/cdkey/logList'},
        {name: '发放奖励日志', route: '/cdkey/rewardsLogList'},
        {name: '问卷调查', route: '/questionnaire/list'},
        {name: '邮件审核', route: '/mail/list'},
        {name: '专属客服配置', route: '/server/csconfigList'},
    ]},
    {name: '数据统计', list: [
        {name: '实时数据', route: '/stats/baseList'},
        {name: '历史数据', route: '/stats/historyList'},
        {name: '冲榜现金礼包', route: '/stats/activityList'},
        {name: '总影响总评分', route: '/stats/influenceList'},
        {name: '区服注册', route: '/stats/registList'},
        {name: '实时在线', route: '/stats/onlineList'},
        {name: '留存统计', route: '/stats/keepList'},
    ]},
    {name: '日志管理', list: [
        // {name: '通知区服记录', route: '/log/noticeList'},
        {name: '发放计费点记录', route: '/log/rechargeList'},
		{name: '发放邮件记录', route: '/mail/sendList'},
    ]},
    {name: '系统管理', list: [
        {name: '用户管理', route: '/user/list'},
    ]},
];

const USER_STATUS_CONFIG = [
	{status: 0, name: '已删', routes: []},
	{status: 1, name: '主策'},
	{status: 2, name: '策划', ignoreNames: ['系统管理']},
	{status: 3, name: '运营', ignoreNames: ['数据统计', '系统管理']},
	{status: 201, name: '专属客服', routes: [
		'/server/csconfigList', '/player/roleList', '/mail/detail', '/player/list',
		'/activity/partList', '/mail/sendList'
	], ignoreOperate: true}
];

const CONFIG_MAP = {};

export const user = {
	username: '',
	password: '',
	token: '',
	time_zone_offset: '',
	status: 0,
	vue: null,
	request: {url: '', params: null},
	requestNum: 0,
	statusName: '已删',
	init: function (axios, vue) {
		let data = localGet('user', {});
		user.username = data.username;
		user.password = data.password;
		user.token = data.token;
		user.time_zone_offset = data.time_zone_offset ? Number(data.time_zone_offset) : '';
		user.status = Number(data.status || 0) || 0;
		user.vue = vue;
		axios.defaults.headers['token'] = user.token;
		console.log('----init', !!user.token, window.location.pathname);

		if (window.location.pathname === '/' || window.location.pathname === '/index.html') {
			if (user.vue) {
				console.log('----init 1', !!user.token);
				user.vue.toHome();
			} else {
				console.log('----init 2', !!user.token);
			}
		}

		let request = localGet('request', user.request);
		user.request.url = request.url;
		user.request.params = request.params ? JSON.parse(request.params) : '';
		user.requestNum = 0;

		let statusConfig = USER_STATUS_CONFIG.find(e => e.status === user.status);
		if (!statusConfig) return [];
		user.statusName = statusConfig.name;

		let configList = helper.cloneDeep(CONFIG_LIST);
		if (statusConfig.ignoreNames) {
			for (let i = 0; i < configList.length; i++) {
				let config = configList[i];
				if (statusConfig.ignoreNames.includes(config.name)) {
					configList.splice(i, 1);
					--i;
				}
			}
		}
		if (statusConfig.routes) {
			for (let i = 0; i < configList.length; i++) {
				let config = configList[i];
				for (let index = 0; index < config.list.length; index++) {
					if (!statusConfig.routes.includes(config.list[index].route)) {
						config.list.splice(index, 1);
						--index;
					}
				}
				if (!config.list.length) {
					configList.splice(i, 1);
					--i;
				}
			}
		}
		return {configList};
	},
	save: function () {
		localSet('user', {username: user.username, password: user.password, token: user.token, status: user.status, time_zone_offset: user.time_zone_offset});
	},
	saveToken: function (token, axios, toLogin = false) {
		user.token = token;
		axios.defaults.headers['token'] = user.token;
		user.save();
		console.log('----saveToken', !!user.token);

		if (toLogin && user.vue) user.vue.reloadLogin();
	},
	saveStatus: function (status) {
		user.status = status;
		user.save();
	},
	saveTimeZone: function (time_zone_offset) {
		user.time_zone_offset = time_zone_offset;
		user.save();
	},
	saveRequest(url, paramsStr) {
		user.request = {url, params: paramsStr ? JSON.parse(paramsStr) : null};
		localSet('request', {url, params: paramsStr});
	}
};

function replaceAll(oldStr, newStr, str) {
	return str.split(oldStr).join(newStr);
}

function parseArray(value) {
    /*if (!value) return [];
    value = replaceAll('\;', '\,', value);
    return JSON.parse(`[${value}]`);*/
    return parseArrayS(value, true);
}

function intArray(arr, must_number) {
    for (let i = 0; i < arr.length; ++i) {
        if (Array.isArray(arr[i])) {
            intArray(arr[i], must_number);
        } else {
            if (!arr[i]) continue;

            let t = Number(arr[i]);
            if (!isNaN(t)) {
                if (t !== Infinity) arr[i] = t;
            } else if (must_number) {
                throw new Error(`intArray invalid number ${arr[i]}`);
            }
        }
    }
}

function parseArrayS(value, must_number = false) {
    if (!value) return [];
    // 添加双引号、替换逗号
    value = replaceAll(";", ",", value);
    value = `[${value}]`;

    value = JSON.parse(value);
    intArray(value, must_number);
    return value;
}

function parseLine(str) {
    let strs = [];
    for (let i = 0; i < str.length; ++i) {
        let j = i + 1;
        if (str[i] === ',') {
            strs.push('');
            if (i === str.length - 1) strs.push('');
            continue;
        } else if (str[i] === '"') {
            let cnt = 1;
            for (; j < str.length; ++j) {
                if (str[j] === '"') {
                    ++cnt;
                } else if (str[j] === ',') {
                    if (cnt % 2 === 0) {
                        --j;
                        break;
                    }
                }
            }
        } else {
            for (; j < str.length; ++j) {
                if (str[j] === ',') {
                    --j;
                    break;
                }
            }
        }

        if (j >= str.length) j = str.length - 1;
        if (str[i] === '"') strs.push(str.substring(i + 1, j).trim());
        else strs.push(str.substring(i, j + 1).trim());
        i = j + 1;
    }
    return strs;
}

export const helper = {
	bool_list: [
		{value: 0, label: '否'},
		{value: 1, label: '是'},
	],
	tableFormatByList: function (row, column, list, field_value = 'value', field_label = 'label', fail_prefix = '', fail_default = '') {
		let value = row[column.property];
		let config = list.find(e => e[field_value] == value);
		if (config) return config[field_label];
		if (fail_prefix) return `${fail_prefix}:${value}`;
		if (fail_default) return fail_default;
		return '';
	},
	tableFormatTimeS: function (row, column) {
		let time = row[column.property];
		if (time) time = helper.timeServerToLocal(time);
		return time ? new Date(time * 1000).FormatAll() : '';
	},
	tableDateRangeFormat: function (beginTime, endTime, forever = false) {
		if (!(beginTime && (endTime || forever))) return '';
		let beginTimeStr = new Date(helper.timeServerToLocal(beginTime) * 1000).FormatAll();
		let endTimeStr = forever ? '永久' : new Date(helper.timeServerToLocal(endTime) * 1000).FormatAll();
		return `${beginTimeStr} ~ ${endTimeStr}`;
	},

	getUserStatusName(status) {
		let statusConfig = USER_STATUS_CONFIG.find(e => e.status === status);
		return statusConfig ? statusConfig.name : '';
	},
	getUserStatusList() {
		return USER_STATUS_CONFIG.filter(e => e.status > 1);
	},
	needOperate() {
		let statusConfig = USER_STATUS_CONFIG.find(e => e.status === user.status);
		return statusConfig && !statusConfig.ignoreOperate;
	},

	validateBool(rule, value, callback) {
		if (!(value == 0 || value == 1)) return callback(new Error("输入错误"));
		callback();
	},
	validateUInt(rule, value, callback) {
		let ok = !!value;
		if (ok) {
			let num = parseInt(value);
			if (isNaN(num) || num < 0) ok = false;
		}
		if (!ok) return callback(new Error("请输入数字"));
		callback();
	},
	validateArray(rule, value, callback) {
		let ok = value && value.length;
		if (!ok) return callback(new Error("请至少选择一个"));
		callback();
	},

	defaultListFirst(data, fieldList, listList, fieldMap = null) {
		for (let i = 0; i < fieldList.length; ++i) {
			let field = fieldList[i];
			let list = listList[i];
			let listField = (fieldMap && fieldMap[field]) ? fieldMap[field] : 'value';
			if (list && list.length) data[field] = list[0][listField];
		}
	},
	numberData(data, fieldList) {
		for (let field of fieldList) {
			let v = data[field];
			if (Array.isArray(v)) {
				for (let i = 0; i < v.length; ++i) v[i] = Number(v[i]);
			} else {
				data[field] = Number(v);
			}
		}
	},
	fixed(value, num = 1) {
        let strList = `${value}`.split('.');
        if (strList[1] && strList[1].length > num) value = Number(`${strList[0]}.${strList[1].substring(0, num)}`);
        return value;
    },

	timeLocalToServer(time) {
		if (`${time}`.length >= 13) time = Math.floor(time / 1000);

		let localTimeZoneOffset = (new Date()).getTimezoneOffset();
		let serverTimeZoneOffset = isNaN(user.time_zone_offset) ? localTimeZoneOffset : user.time_zone_offset;
		let newTime = time - localTimeZoneOffset * 60 + serverTimeZoneOffset * 60;
		return newTime;
	},
	timeServerToLocal(time) {
		if (`${time}`.length >= 13) time = Math.floor(time / 1000);

		let localTimeZoneOffset = (new Date()).getTimezoneOffset();
		let serverTimeZoneOffset = isNaN(user.time_zone_offset) ? localTimeZoneOffset : user.time_zone_offset;
		let newTime = time - serverTimeZoneOffset * 60 + localTimeZoneOffset * 60;
		return newTime;
	},
	fromLocalTimeList(time_list) {
		if (!(time_list && time_list.length === 2)) return null;
		return {
			min: helper.timeLocalToServer(new Date(time_list[0]).getTime()),
			max: helper.timeLocalToServer(new Date(time_list[1]).getTime()),
		};
	},
	toLocalTimeList(min, max) {
		if (!(min && max)) return [];
		return [new Date(helper.timeServerToLocal(min) * 1000), new Date(helper.timeServerToLocal(max) * 1000)];
	},
	serverDate(diffTime = 0) {
		const time = helper.timeServerToLocal(new Date().getTime());
		return new Date((time + diffTime) * 1000);
	},
	stringToJson(str) {
		let obj = null;
		try {obj = JSON.parse(str);}
		catch (e) {obj = null;}
		return obj;
	},
	jsonToString(obj) {
		let str = '';
		try {str = JSON.stringify(obj);}
		catch (e) {str = '';}
		return str;
	},
	cloneDeep(obj) {
		return JSON.parse(JSON.stringify(obj));
	},
	checkEditParams(editData, prevData, toJsonList) {
		let params = {};
		Object.assign(params, editData);
		if (toJsonList && toJsonList.length) {
			for (let k of toJsonList) {
				if (params[k] !== undefined) params[k] = helper.jsonToString(params[k]);
			}
		}
		if (prevData) {
			for (let k in prevData) {
				if (prevData[k] == params[k]) delete params[k];
			}
			if (Object.keys(params).length === 0) {
				return null;
			}
			params.id = prevData.id;
		}
		
		return params;
	},
	downloadFile(str, filename) {
		const iconv = require('iconv-lite');
		str = iconv.encode(str, 'gbk');

		let blob = new Blob([str], {type: 'text/csv;charset=GBK'});
		let href = window.URL.createObjectURL(blob);
		
		let a = document.createElement('a');
		a.style.display = 'none';
		a.setAttribute('download', filename);
		a.href = href;
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
		window.URL.revokeObjectURL(href);
	},
	back() {
		window.isBack = true;
		window.history.back();
	},
	csvToJson(str) {
		const iconv = require('iconv-lite');
		let str_list = iconv.decode(str, 'utf8', {stripBOM: true}).split('\n');
		let obj = {nameList: [], fieldList: [], typeList: [], list: []};
		for (let i = 0; i < str_list.length; ++i) {
			let data_str = str_list[i];
			while (data_str.length) {
				let last_char = data_str[data_str.length - 1];
				if (last_char === '\r' || last_char === '\n' || last_char === '\t') {
					data_str = data_str.substring(0, data_str.length - 1);
				} else {
					break;
				}
			}

			let strs = parseLine(data_str);
			if (!strs[0]) continue;

			if (i === 0) {
				obj.nameList = strs;
			} else if (i === 1) {
				obj.fieldList = strs;
			} else if (i === 2) {
				obj.typeList = strs;
			} else {
				let data = {};
				for (let j = 0; j < obj.fieldList.length; ++j) {
					let field = obj.fieldList[j];
					if (!field) continue;

					let type = obj.typeList[j] || 'string';
					let value = strs[j];
					if (type === 'number') {
						value = Number(value || 0) || 0;
						if (isNaN(value)) throw new Error(`invalid number ${value}`);
						if (value === Infinity) value = strs[j];
					} else if (type === 'array') {
						value = parseArray(value);
					} else if (type === 'array_s') {
						value = parseArrayS(value);
					} else if (type === 'all') {
						if (value.match(';')) {
							if (value.endsWith(';')) value = value.substring(0, value.length - 1);
							value = parseArrayS(value);
						} else {
							let t = Number(value);
							if (!isNaN(t)) value = t;
							else value = value || '';
						}
					} else {
						value = value || '';
						if (value) {
							value = replaceAll('""', '"', value);
							if (type === 'string_s') value = value.replace(/"/g, '');
						}
					}
					if (field === 'rewards') {
						let newValue = [];
						for (let info of value) {
							newValue.push({item_id: info[0], num: info[1]});
						}
						value = newValue;
					}
					data[field] = value;
				}
				obj.list.push(data);
			}
		}
		return obj;
	},
	async loadConfigList(axios, name) {
		if (!CONFIG_MAP[name]) CONFIG_MAP[name] = (await axios.post('/player/configList', {name})).msg.list;
		return CONFIG_MAP[name];
	},
};